import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import useMedia from "../../hooks/useMedia";

if (!document.getElementById("comm-fonts")) {
  const l = document.createElement("link");
  l.id = "comm-fonts"; l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Raleway:wght@400;500;600;700&display=swap";
  document.head.appendChild(l);
}

if (!document.getElementById("comm-kf")) {
  const s = document.createElement("style");
  s.id = "comm-kf";
  s.textContent = `
    @keyframes commCardEntrance {
      from { opacity: 0; transform: translateY(24px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    .comm-card {
      transition: box-shadow 0.35s ease, border-color 0.35s ease,
                  transform 0.32s cubic-bezier(.22,1,.36,1);
      will-change: transform;
    }
    .comm-card:not(.comm-card--open):hover {
      transform: translateY(-5px) scale(1.01);
      box-shadow: 0 24px 60px rgba(120,60,10,0.15) !important;
    }
    .comm-card--open {
      box-shadow: 0 24px 80px rgba(120,60,10,0.22) !important;
    }
    .comm-hero-img {
      transition: transform 0.55s cubic-bezier(.22,1,.36,1);
      will-change: transform;
    }
    .comm-card:not(.comm-card--open):hover .comm-hero-img {
      transform: scale(1.06);
    }
    .comm-expand-body {
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.42s cubic-bezier(.32,1,.28,1);
    }
    .comm-expand-body.open {
      grid-template-rows: 1fr;
    }
    .comm-expand-inner {
      overflow: hidden;
      min-height: 0;
    }
    .comm-toggle-btn {
      display: flex; align-items: center; gap: 5px;
      font-family: 'Raleway', sans-serif; font-size: 11px;
      color: #d97706; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;
      background: none; border: none; cursor: pointer; padding: 0;
      transition: color 0.2s, gap 0.2s;
    }
    .comm-toggle-btn:hover { color: #92400e; gap: 8px; }
    .comm-toggle-btn .t-arrow {
      display: inline-block; font-size: 16px; line-height: 1;
      transition: transform 0.35s cubic-bezier(.32,1,.28,1);
    }
    .comm-card--open .comm-toggle-btn .t-arrow { transform: rotate(90deg); }
    .comm-close-btn {
      background: #7c2d12; color: #fff; border: none;
      padding: 9px 22px; border-radius: 6px;
      font-family: 'Raleway', sans-serif; font-size: 10px;
      font-weight: 700; letter-spacing: 2px; text-transform: uppercase;
      cursor: pointer; transition: background 0.2s, transform 0.15s;
    }
    .comm-close-btn:hover { background: #2d6b5e; transform: scale(1.03); }
    .comm-genre-tab { transition: all 0.2s ease; }
    .comm-genre-tab:hover { transform: translateY(-1px); }
    .comm-img-thumb {
      transition: transform 0.35s cubic-bezier(.22,1,.36,1), box-shadow 0.3s ease;
      cursor: pointer; will-change: transform;
    }
    .comm-img-thumb:hover { transform: scale(1.03); box-shadow: 0 10px 32px rgba(0,0,0,0.2); }
    .comm-img-overlay {
      position: absolute; inset: 0;
      background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 55%);
      opacity: 0; transition: opacity 0.25s ease;
      display: flex; flex-direction: column;
      justify-content: flex-end; padding: 10px;
      pointer-events: none;
    }
    .comm-img-thumb:hover .comm-img-overlay { opacity: 1; }
    .comm-row-divider {
      display: flex; align-items: center; gap: 12px;
      margin: 4px 0; opacity: 0.4;
    }
    .comm-row-divider-line {
      flex: 1; height: 1px;
      background: linear-gradient(to right, transparent, rgba(146,64,14,0.35), transparent);
    }
    .comm-row-divider-ornament {
      color: #92400e; font-size: 10px; letter-spacing: 6px;
      font-family: 'Cormorant Garamond', Georgia, serif; opacity: 0.7;
    }
    .comm-lightbox {
      position: fixed; inset: 0; z-index: 999999;
      background: rgba(10,8,6,0.55);
      touch-action: none;
      display: flex; align-items: center; justify-content: center;
      animation: commLbIn 0.2s ease;
    }
    @keyframes commLbIn { from{opacity:0} to{opacity:1} }
    .comm-lightbox-img {
      max-width: 88vw; max-height: 82vh; border-radius: 8px;
      box-shadow: 0 32px 100px rgba(0,0,0,0.4);
      animation: commLbImgIn 0.26s cubic-bezier(.22,1,.36,1);
    }
    @keyframes commLbImgIn {
      from { opacity:0; transform:scale(0.93); }
      to   { opacity:1; transform:scale(1); }
    }
    @media (max-width: 700px) {
      .comm-card:not(.comm-card--open):hover { transform: none !important; box-shadow: none !important; }
      .comm-card:not(.comm-card--open):hover .comm-hero-img { transform: none !important; }
      .comm-masonry { grid-template-columns: repeat(2,1fr) !important; }
    }
    @media (max-width: 420px) {
      .comm-masonry { grid-template-columns: 1fr !important; }
    }
  `;
  document.head.appendChild(s);
}

const GENRE_COLORS = {
  Sports: { bg: "rgba(37,99,235,0.08)", text: "#1d4ed8", dot: "#2563eb", border: "rgba(37,99,235,0.25)" },
  Worship: { bg: "rgba(124,45,18,0.09)", text: "#7c2d12", dot: "#7c2d12", border: "rgba(124,45,18,0.25)" },
  Events: { bg: "rgba(217,119,6,0.09)", text: "#b45309", dot: "#d97706", border: "rgba(217,119,6,0.25)" },
  Trip: { bg: "rgba(5,150,105,0.08)", text: "#059669", dot: "#059669", border: "rgba(5,150,105,0.25)" },
  Missions: { bg: "rgba(220,38,38,0.08)", text: "#b91c1c", dot: "#dc2626", border: "rgba(220,38,38,0.25)" },
  Prayer: { bg: "rgba(109,40,217,0.08)", text: "#6d28d9", dot: "#6d28d9", border: "rgba(109,40,217,0.25)" },
  Other: { bg: "rgba(120,113,108,0.08)", text: "#57534e", dot: "#78716c", border: "rgba(120,113,108,0.25)" },
};

const communities = [
  { name: "Community No. 1", desc: "Brings together parish members from the northern areas to grow in faith, support one another, and participate actively in parish life.", priest: "Fr. Terence Murray", coordinator: "Venus Chedda", mobile: "9967118354", meetingDay: "Tuesday", time: "After 7 pm Mass", venue: "Basement Room" },
  { name: "Community No. 2", desc: "Unites families from the eastern neighbourhoods through shared prayer, service, and celebration of faith.", priest: "Fr. Terence Murray", coordinator: "Diana Dias", mobile: "9920399346", meetingDay: "2nd Saturday", time: "5:30 pm/ 6:00 pm", venue: "Basement" },
  { name: "Community No. 3", desc: "A vibrant community of parishioners committed to fellowship, outreach, and spiritual growth together.", priest: "Fr. Tarsicius Fernandes", coordinator: "Nalini Dsouza", mobile: "9867111226", meetingDay: "Online", time: "5:30 p.m.", venue: "At the Convenience of all" },
  { name: "Community No. 4", desc: "Fosters close bonds among members through regular gatherings, liturgical participation, and community service.", priest: "Fr. Clarence Sequeira", coordinator: "Jacinta Alexander", mobile: "9819149971", meetingDay: "2nd Sunday", time: "After 10 am Mass", venue: "Basement Room" },
  { name: "Community No. 5", desc: "Brings parishioners together around a shared vision of faith-in-action, rooted in the local neighbourhood.", priest: "Fr. Clarence Sequeira", coordinator: "Yogita Parmar", mobile: "9869286296", meetingDay: "2nd Sunday", time: "5 p.m.", venue: "Basement Room" },
  { name: "Community No. 6", desc: "A welcoming community that journeys together through the seasons of parish and family life.", priest: "Fr. Tarsicius Fernandes", coordinator: "Isabel Dcruz", mobile: "9820065666", meetingDay: "Monday after PPC meet", time: "7.30 p.m.", venue: "Animator's House" },
  { name: "Community No. 7", desc: "Dedicated to building a strong, prayerful community that serves one another and the wider parish.", priest: "Fr. Terence Murray", coordinator: "Sebastian Mendonca", mobile: "8779628909", meetingDay: "1st Week", time: "7 p.m.", venue: "Basement Room" },
  { name: "Community No. 8", desc: "A neighborhood community group fostering local fellowship and prayer.", priest: "Fr. Clarence Sequeira", coordinator: "Ryan D'souza", mobile: "9967875038", meetingDay: "2nd Saturday", time: "5 p.m.", venue: "Basement Room" },
];

function GenreBadge({ genre }) {
  const c = GENRE_COLORS[genre] || GENRE_COLORS.Other;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      padding: "3px 9px", borderRadius: 20,
      background: c.bg, color: c.text, border: `1px solid ${c.border}`,
      fontFamily: "'Raleway',sans-serif", fontSize: 9,
      fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", whiteSpace: "nowrap",
    }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: c.dot, flexShrink: 0 }} />
      {genre}
    </span>
  );
}

function RowDivider() {
  return (
    <div className="comm-row-divider">
      <div className="comm-row-divider-line" />
      <span className="comm-row-divider-ornament">✦ ✦ ✦</span>
      <div className="comm-row-divider-line" />
    </div>
  );
}

// Rendered via portal so it always escapes overflow:hidden on mobile
function Lightbox({ img, onClose }) {
  useEffect(() => {
    const fn = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [onClose]);

  // Ensure portal root exists
  const el = useRef(document.getElementById("comm-lightbox-root") || (() => {
    const div = document.createElement("div");
    div.id = "comm-lightbox-root";
    div.style.cssText = "position:fixed;inset:0;z-index:999999;pointer-events:none;";
    document.body.appendChild(div);
    return div;
  })());

  useLayoutEffect(() => {
    const node = el.current;
    node.style.pointerEvents = "auto";
    return () => { node.style.pointerEvents = "none"; };
  }, []);

  return createPortal(
    <div className="comm-lightbox" onPointerUp={onClose}>
      <div onPointerUp={e => e.stopPropagation()} style={{ position: "relative", maxWidth: "90vw" }}>
        <img src={img.image_url} alt={img.caption || ""} className="comm-lightbox-img" />
        {img.caption && (
          <p style={{ textAlign: "center", marginTop: 10, fontFamily: "'Raleway',sans-serif", fontSize: 12, color: "rgba(255,255,255,0.85)" }}>
            {img.caption}
          </p>
        )}
        <button onPointerUp={e => { e.stopPropagation(); onClose(); }} style={{
          position: "absolute", top: -12, right: -12, width: 30, height: 30, borderRadius: "50%",
          background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: 14,
          cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
        }}>✕</button>
      </div>
    </div>,
    el.current
  );
}

function ImageSection({ images }) {
  const [activeGenre, setActiveGenre] = useState("All");
  const [lightboxImg, setLightboxImg] = useState(null);

  const genres = ["All", ...Array.from(new Set(
    images.map(img => img.category || "Other")
  )).sort()];

  const displayed = activeGenre === "All"
    ? images
    : images.filter(img => (img.category || "Other") === activeGenre);

  const columns = [[], [], []];
  displayed.forEach((img, i) => columns[i % 3].push(img));

  return (
    <div style={{ marginTop: 16 }}>
      {genres.length > 2 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 }}>
          {genres.map(genre => {
            const active = activeGenre === genre;
            const c = GENRE_COLORS[genre] || GENRE_COLORS.Other;
            return (
              <button key={genre} className="comm-genre-tab" onClick={() => setActiveGenre(genre)} style={{
                padding: "5px 14px", borderRadius: 20,
                border: active ? `1.5px solid ${c.border}` : "1.5px solid rgba(0,0,0,0.08)",
                background: active ? c.bg : "rgba(255,255,255,0.7)",
                color: active ? c.text : "#9a9490",
                fontFamily: "'Raleway',sans-serif", fontSize: 10, fontWeight: 700,
                letterSpacing: "0.8px", textTransform: "uppercase", cursor: "pointer",
                boxShadow: active ? `0 2px 10px ${c.bg}` : "none",
              }}>
                {genre}
                <span style={{ marginLeft: 5, opacity: 0.55, fontWeight: 400 }}>
                  {genre === "All" ? images.length : images.filter(i => (i.category || "Other") === genre).length}
                </span>
              </button>
            );
          })}
        </div>
      )}
      {displayed.length > 0 ? (
        <div className="comm-masonry" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, alignItems: "start" }}>
          {columns.map((col, colIdx) => (
            <div key={colIdx} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {col.map((img, i) => (
                <div key={i} className="comm-img-thumb"
                  onClick={e => { e.stopPropagation(); e.preventDefault(); }}
                  onPointerUp={e => { e.stopPropagation(); setLightboxImg(img); }}
                  style={{ borderRadius: 10, overflow: "hidden", position: "relative", background: "#f5e6d0" }}>
                  <img src={img.image_url} alt={img.caption || img.category || ""}
                    style={{ width: "100%", height: "auto", display: "block" }} loading="lazy" />
                  <div className="comm-img-overlay">
                    <GenreBadge genre={img.category || "Other"} />
                    {img.caption && (
                      <p style={{ margin: "5px 0 0", fontFamily: "'Raleway',sans-serif", fontSize: 11, color: "rgba(255,255,255,0.85)", lineHeight: 1.4 }}>
                        {img.caption}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "28px 0", fontFamily: "'Raleway',sans-serif", fontSize: 12, color: "#c4b5a0" }}>
          No images in this category yet
        </div>
      )}
      {lightboxImg && <Lightbox img={lightboxImg} onClose={() => setLightboxImg(null)} />}
    </div>
  );
}

function CommunityCard({ community, images, isOpen, onToggle, cardRef, entranceDelay }) {
  const heroImg = images[0];
  return (
    <article
      ref={cardRef}
      className={`comm-card${isOpen ? " comm-card--open" : ""}`}
      onClick={onToggle}
      style={{
        borderRadius: 16, overflow: "hidden", background: "#fff",
        border: isOpen ? "1px solid rgba(217,119,6,0.4)" : "1px solid rgba(217,119,6,0.12)",
        borderLeft: isOpen ? "3px solid #d97706" : undefined,
        boxShadow: "0 2px 4px rgba(0,0,0,0.03), 0 8px 32px rgba(120,60,10,0.07)",
        display: "flex", flexDirection: "column", cursor: "pointer", height: "100%",
        animation: `commCardEntrance 0.55s ${entranceDelay}s cubic-bezier(.22,1,.36,1) both`,
      }}
    >
      {/* Hero */}
      <div style={{
        height: isOpen ? 280 : 200, flexShrink: 0, overflow: "hidden",
        background: "linear-gradient(135deg,#fef3c7,#fde68a)", position: "relative",
        transition: "height 0.42s cubic-bezier(.32,1,.28,1)",
      }}>
        {heroImg ? (
          <img src={heroImg.image_url} alt={heroImg.caption || community.name}
            className="comm-hero-img"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            loading="lazy" />
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontSize: 44, opacity: 0.15, color: "#92400e" }}>✝</span>
          </div>
        )}
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top,rgba(0,0,0,0.3) 0%,rgba(0,0,0,0.05) 40%,transparent 70%)" }} />
        {images.length > 0 && (
          <div style={{ position: "absolute", top: 12, right: 12 }}>
            <span style={{
              display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 9px", borderRadius: 20,
              background: "rgba(0,0,0,0.42)", color: "#fff", fontFamily: "'Raleway',sans-serif",
              fontSize: 10, fontWeight: 700, backdropFilter: "blur(4px)",
            }}>📷 {images.length}</span>
          </div>
        )}
        {isOpen && (
          <div style={{ position: "absolute", bottom: 14, left: 16, right: 16 }}>
            <p style={{ fontFamily: "'Cormorant Garamond',Georgia,serif", fontSize: 22, fontWeight: 700, color: "#fff", margin: 0, lineHeight: 1.2, textShadow: "0 2px 12px rgba(0,0,0,0.5)" }}>
              {community.name}
            </p>
          </div>
        )}
      </div>

      {/* Static content */}
      <div style={{ padding: "18px 20px 14px", display: "flex", flexDirection: "column", gap: 8, flex: 1 }}>
        {!isOpen && (
          <h2 style={{ fontFamily: "'Cormorant Garamond',Georgia,serif", fontSize: 21, fontWeight: 700, color: "#7c2d12", margin: 0, lineHeight: 1.2 }}>
            {community.name}
          </h2>
        )}
        <p style={{ fontFamily: "'Raleway',sans-serif", fontSize: 13, color: "#78716c", lineHeight: 1.7, margin: 0 }}>
          {community.desc}
        </p>
        <div style={{ marginTop: "auto", paddingTop: 6, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <button className="comm-toggle-btn" onClick={e => { e.stopPropagation(); onToggle(); }}>
            <span>{isOpen ? "Show less" : "View photos & info"}</span>
            <span className="t-arrow">›</span>
          </button>
          {!isOpen && (
            <span style={{ fontFamily: "'Raleway',sans-serif", fontSize: 10, color: "#c4b5a0" }}>tap to expand</span>
          )}
        </div>
      </div>

      <div style={{
        height: 1, margin: "0 20px",
        background: "linear-gradient(to right,rgba(217,119,6,0.2),transparent)",
        opacity: isOpen ? 1 : 0, transition: "opacity 0.3s ease",
      }} />

      {/* Expandable */}
      <div
        className={`comm-expand-body${isOpen ? " open" : ""}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="comm-expand-inner">
          <div style={{
            padding: "6px 20px 24px",
            opacity: isOpen ? 1 : 0,
            transform: isOpen ? "translateY(0)" : "translateY(8px)",
            transition: "opacity 0.3s ease 0.15s, transform 0.3s ease 0.15s",
          }}>

            {/* Community Info Grid using Excel Data */}
            <div style={{
              display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px",
              margin: "10px 0 20px", padding: "16px",
              background: "rgba(250,248,245,0.8)", borderRadius: 8,
              border: "1px solid rgba(120,60,10,0.08)",
              fontFamily: "'Raleway', sans-serif", fontSize: 12.5, color: "#57534e"
            }}>
              {community.priest && community.priest !== "N/A" && <div><strong style={{ color: "#7c2d12" }}>Priest In-Charge:</strong><br />{community.priest}</div>}
              {community.coordinator && community.coordinator !== "N/A" && <div><strong style={{ color: "#7c2d12" }}>Co-ordinator:</strong><br />{community.coordinator}</div>}
              {community.mobile && community.mobile !== "N/A" && <div><strong style={{ color: "#7c2d12" }}>Mobile:</strong><br />{community.mobile}</div>}
              {community.meetingDay && community.meetingDay !== "N/A" && <div><strong style={{ color: "#7c2d12" }}>Meeting Day:</strong><br />{community.meetingDay}</div>}
              {community.time && community.time !== "N/A" && <div><strong style={{ color: "#7c2d12" }}>Time:</strong><br />{community.time}</div>}
              {community.venue && community.venue !== "N/A" && <div><strong style={{ color: "#7c2d12" }}>Venue:</strong><br />{community.venue}</div>}
            </div>

            {images.length > 0 ? (
              <ImageSection images={images} />
            ) : (
              <div style={{ textAlign: "center", padding: "36px 0", fontFamily: "'Cormorant Garamond',Georgia,serif", fontSize: 18, color: "#c4b5a0", fontStyle: "italic" }}>
                No photos yet — check back soon
              </div>
            )}
            <div style={{ marginTop: 20 }}>
              <button className="comm-close-btn" onClick={onToggle}>Close</button>
            </div>
          </div>
        </div>
      </div>

      <div style={{
        height: 3,
        background: isOpen ? "#d97706" : "linear-gradient(to right,#92400e,#d97706,#b45309)",
        flexShrink: 0, marginTop: "auto", transition: "background 0.35s ease",
      }} />
    </article>
  );
}

export default function Communities() {
  const [openIdx, setOpenIdx] = useState(null);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 700);
  const cardRefs = useRef({});
  const media = useMedia();

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 700px)");
    const update = () => {
      setIsMobile(mq.matches);
      if (mq.matches) setOpenIdx(null);
    };
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  useEffect(() => {
    const fn = (e) => { if (e.key === "Escape") setOpenIdx(null); };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, []);

  const handleToggle = useCallback((idx) => {
    setOpenIdx(prev => {
      const next = prev === idx ? null : idx;
      if (next !== null) {
        setTimeout(() => {
          const el = cardRefs.current[idx];
          if (el) {
            const rect = el.getBoundingClientRect();
            const scrollTarget = window.scrollY + rect.top - (window.innerHeight / 2) + (rect.height / 2);
            window.scrollTo({ top: scrollTarget, behavior: "smooth" });
          }
        }, 80);
      }
      return next;
    });
  }, []);

  const rows = [];
  for (let i = 0; i < communities.length; i += 2) rows.push(communities.slice(i, i + 2));

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(160deg,#fefce8 0%,#fffbf0 35%,#fafaf9 100%)", position: "relative" }}>
      <div style={{ position: "relative", zIndex: 1 }}>

        <header style={{ maxWidth: 1100, margin: "0 auto", padding: "64px 24px 40px", textAlign: "center" }}>
          <p style={{ fontFamily: "'Raleway',sans-serif", fontSize: 10, letterSpacing: "5px", textTransform: "uppercase", color: "#d97706", margin: "0 0 12px", fontWeight: 700 }}>
            Saint Stephen's Church
          </p>
          <h1 style={{ fontFamily: "'Cormorant Garamond',Georgia,serif", fontSize: "clamp(34px,5.5vw,60px)", fontWeight: 700, color: "#7c2d12", margin: "0 0 16px", lineHeight: 1.05, letterSpacing: "-0.5px" }}>
            Parish Communities
          </h1>
          <div style={{ width: 56, height: 2, background: "linear-gradient(to right,#92400e,#d97706,transparent)", borderRadius: 2, margin: "0 auto 20px" }} />
          <p style={{ fontFamily: "'Raleway',sans-serif", fontSize: 15, color: "#8a8075", maxWidth: 520, margin: "0 auto", lineHeight: 1.75 }}>
            Our parish is divided into eight communities that foster fellowship, shared responsibility, and active participation in parish life.
          </p>
        </header>

        <main style={{ maxWidth: 1100, margin: "0 auto", padding: "0 24px 100px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {rows.map((row, rowIdx) => {
              const idxA = rowIdx * 2;
              const idxB = row[1] ? rowIdx * 2 + 1 : null;

              const aOpen = openIdx === idxA;
              const bOpen = idxB !== null && openIdx === idxB;
              const aCollapsed = !isMobile && bOpen;
              const bCollapsed = !isMobile && aOpen;

              let desktopCols = "1fr 1fr";
              if (!isMobile && aOpen) desktopCols = "1fr 0fr";
              if (!isMobile && bOpen) desktopCols = "0fr 1fr";
              const gridCols = isMobile ? "1fr" : desktopCols;

              return (
                <div key={rowIdx}>
                  {rowIdx > 0 && <RowDivider />}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: gridCols,
                    gap: isMobile ? 16 : (aOpen || bOpen) ? 0 : 20,
                    alignItems: "stretch",
                    transition: "grid-template-columns 0.42s cubic-bezier(.32,1,.28,1), gap 0.42s ease",
                    padding: "10px 0",
                  }}>
                    <div style={{
                      overflow: "hidden", minWidth: 0,
                      opacity: aCollapsed ? 0 : 1,
                      transform: aCollapsed ? "scale(0.94)" : "scale(1)",
                      transition: "opacity 0.32s ease, transform 0.32s ease",
                    }}>
                      <CommunityCard
                        community={row[0]}
                        images={media.filter(m => m.section === "community" && m.subgroup === String(idxA + 1)).sort((a, b) => (a.order ?? 0) - (b.order ?? 0))}
                        isOpen={aOpen}
                        cardRef={el => cardRefs.current[idxA] = el}
                        onToggle={() => handleToggle(idxA)}
                        entranceDelay={Math.min(rowIdx * 0.07, 0.3)}
                      />
                    </div>

                    {row[1] && (
                      <div style={{
                        overflow: "hidden", minWidth: 0,
                        opacity: bCollapsed ? 0 : 1,
                        transform: bCollapsed ? "scale(0.94)" : "scale(1)",
                        transition: "opacity 0.32s ease, transform 0.32s ease",
                      }}>
                        <CommunityCard
                          community={row[1]}
                          images={media.filter(m => m.section === "community" && m.subgroup === String(idxB + 1)).sort((a, b) => (a.order ?? 0) - (b.order ?? 0))}
                          isOpen={bOpen}
                          cardRef={el => cardRefs.current[idxB] = el}
                          onToggle={() => handleToggle(idxB)}
                          entranceDelay={Math.min(rowIdx * 0.07 + 0.04, 0.3)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </main>
      </div>
    </div>
  );
}